// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2uRb_","content":"GlobalSearch_content__3Apx3"};